import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  ListGroup,
  ListGroupItem,
  Button,
} from "reactstrap";
import axios from "axios";
import ReactJson from "react-json-view";
import { RunTestReport } from "../../runTestReport";
import { configActions } from "../../../../../redux/actions";
import { getReportData } from "../../../../../utils";
import { WizardFormSecondPage } from "../../../../../components/NewReportWizard";

class CopyNewConfigReport extends React.Component {
  state = {
    fullEventModal: false,
    eventJsonObj: {},
    msg: {},
    invalidFtpConfirmModal: false,
    savingReport: false,
    showMoreDesc: false,
    keepOpen: false,

    isActive: this.props.isActive,
    internalUse: this.props.internalUse,

    selectedReport: null,
    selectedReportId: "",
    selectedReportScheduleId: "",
  };

  closeWindow = () => {
    this.props.dispatch(configActions.toggleCopyNewConfigReportModal(false));
  };

  handleOpenFullEventClick = (dataObject) => {
    if (dataObject) {
      this.setState({
        eventJsonObj: dataObject,
        fullEventModal: true,
      });
    }
  };

  toggleFullEventModal = () => {
    this.setState({
      fullEventModal: !this.state.fullEventModal,
    });
  };

  handleOnSubmit = (data, selectedReportType, resetLoader, keepOpen) => {
    let reportData = getReportData(data, selectedReportType);
    if (
      reportData.validationErrorMsgs &&
      reportData.validationErrorMsgs.length
    ) {
      if (resetLoader) resetLoader();
      this.setState({
        resetLoader: null,
        msg: {
          header: "Validation Error",
          message: (
            <ListGroup>
              {reportData.validationErrorMsgs.map((item, index) => (
                <ListGroupItem
                  key={index}
                  color="danger"
                  dangerouslySetInnerHTML={{
                    __html: item,
                  }}
                />
              ))}
            </ListGroup>
          ),
        },
      });
    } else if (reportData.schedulesConfirmRequired) {
      this.setState({
        resetLoader,
        keepOpen,
      });
    } else {
      this.saveReport(reportData.data, resetLoader, keepOpen);
    }
  };

  saveReport = (params, resetLoader, keepOpen) => {
    var isUpdate = false;
    let updateDefinition = false;
    let updateSchedule = false;
    const { config } = this.props;

    const originalDefinitionParams = Object.assign({}, config.reportForCopyNew);
    delete originalDefinitionParams["schedules"];

    const definitionParams = Object.assign({}, params);
    delete definitionParams["schedules"];

    updateDefinition =
      JSON.stringify(originalDefinitionParams) !==
      JSON.stringify(definitionParams);

    // call update schudules if triggerType === "recurringreport"
    let schedulesParams;
    if (
      params.triggerType === "recurringreport" &&
      params.schedules &&
      params.schedules[0]
    ) {
      const originalSchedulesParams =
        config.reportForCopyNew.schedules &&
        config.reportForCopyNew.schedules[0]
          ? Object.assign({}, config.reportForCopyNew.schedules[0], {
              state: config.reportForCopyNew.active ? "Pending" : "Canceled",
            })
          : null;

      schedulesParams = Object.assign({}, params.schedules[0], {
        //reportdefinitionid: response.data.Data["_id"],
        state: params.active ? "Pending" : "Canceled",
      });

      updateSchedule =
        JSON.stringify(originalSchedulesParams) !==
        JSON.stringify(schedulesParams);
    }

    if (isUpdate && this.state.selectedReportId) {
      definitionParams._id = this.state.selectedReportId;
    }
    if (isUpdate && this.state.selectedReportScheduleId) {
      schedulesParams._id = this.state.selectedReportScheduleId;
    }
    if (!isUpdate) {
      this.insertDefinition(
        definitionParams,
        updateSchedule,
        schedulesParams,
        resetLoader,
        params,
        keepOpen
      );
      return;
    } else if (updateDefinition) {
      this.updateDefinition(
        definitionParams,
        updateSchedule,
        schedulesParams,
        resetLoader,
        keepOpen
      );
    } else if (updateSchedule) {
      this.updateSchedule(schedulesParams, resetLoader, params, keepOpen);
    } else if (keepOpen) {
      if (resetLoader) resetLoader();
      this.setState({
        resetLoader: null,
        msg: {
          header: "Report Update",
          message: <Alert color="danger">Nothing to update</Alert>,
        },
      });
    } else {
      if (resetLoader) resetLoader();
      this.setState({
        resetLoader: null,
        msg: {
          header: "Report Update",
          message: <Alert color="success">Report updated successfully</Alert>,
        },
      });
      this.closeWindow();
    }
  };

  insertDefinition = (
    definitionParams,
    updateSchedule,
    schedulesParams,
    resetLoader,
    params,
    keepOpen
  ) => {
    axios
      .post("Reporting/Definitions/Insert", definitionParams)
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          this.setState({
            resetLoader: null,
            msg: {
              header: "Server Error",
              message: (
                <Alert color="danger">
                  <p>Server failed with the following errors:</p>
                  {response.data.Errors.join("<br />")}
                </Alert>
              ),
            },
          });
        } else {
          if (
            response.data.ValidationErrors &&
            response.data.ValidationErrors.length
          ) {
            if (resetLoader) resetLoader();
            this.setState({
              resetLoader: null,
              msg: {
                header: "Validation Error",
                message: (
                  <Alert color="danger">
                    <p>The following field(s) are missed:</p>
                    {response.data.ValidationErrors.join("<br />")}
                  </Alert>
                ),
              },
            });
          } else {
            this.setState({
              selectedReportId: response.data.Data._id,
            });
            if (updateSchedule) {
              schedulesParams["reportdefinitionid"] = response.data.Data._id;
              this.insertSchedule(
                schedulesParams,
                resetLoader,
                params,
                keepOpen
              );
            } else {
              if (resetLoader) resetLoader();
              /* this.setState({
							}); */
              this.setState({
                resetLoader: null,
                selectedReport: JSON.parse(JSON.stringify(params)),
                msg: {
                  header: "Report Added",
                  message: (
                    <Alert color="success">Report added successfully</Alert>
                  ),
                },
              });
              if (!keepOpen) this.closeWindow();
              this.props.handlePageReload && this.props.handlePageReload();
            }
          }
        }
      });
  };

  updateDefinition = (
    definitionParams,
    updateSchedule,
    schedulesParams,
    resetLoader,
    keepOpen
  ) => {
    axios
      .put("Reporting/Definitions/Update", definitionParams)
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          this.setState({
            resetLoader: null,
            msg: {
              header: "Server Error",
              message: (
                <Alert color="danger">
                  <p>Server failed with the following errors:</p>
                  {response.data.Errors.join("<br />")}
                </Alert>
              ),
            },
          });
        } else {
          if (
            response.data.ValidationErrors &&
            response.data.ValidationErrors.length
          ) {
            if (resetLoader) resetLoader();
            this.setState({
              resetLoader: null,
              msg: {
                header: "Validation Error",
                message: (
                  <Alert color="danger">
                    <p>The following fields are missed:</p>
                    {response.data.ValidationErrors.join("<br />")}
                  </Alert>
                ),
              },
            });
          } else if (updateSchedule) {
            this.updateSchedule(schedulesParams, resetLoader, keepOpen);
          } else {
            // reload and close window
            if (resetLoader) resetLoader();
            this.setState({
              resetLoader: null,
              msg: {
                header: "Report Update",
                message: (
                  <Alert color="success">Report updated successfully</Alert>
                ),
              },
            });
            if (!keepOpen) this.closeWindow();
            this.props.handlePageReload && this.props.handlePageReload();
          }
        }
      });
  };

  insertSchedule = (schedulesParams, resetLoader, params, keepOpen) => {
    axios
      .post("Reporting/Schedules/Insert", { Data: schedulesParams })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          this.setState({
            resetLoader: null,
            msg: {
              header: "Server Error",
              message: (
                <Alert color="danger">
                  <p>Server failed with the following errors:</p>
                  {response.data.Errors.join("<br />")}
                </Alert>
              ),
            },
          });
        } else {
          if (resetLoader) resetLoader();
          this.setState({
            selectedReport: JSON.parse(JSON.stringify(params)),
            resetLoader: null,
            msg: {
              header: "Report Added",
              message: <Alert color="success">Report added successfully</Alert>,
            },
            selectedReportScheduleId: response.data.Data._id,
          });
          if (!keepOpen) this.closeWindow();
          this.props.handlePageReload && this.props.handlePageReload();
        }
      });
  };

  updateSchedule = (schedulesParams, resetLoader, params, keepOpen) => {
    axios
      .put("Reporting/Schedules/Update", { Data: schedulesParams })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          this.setState({
            resetLoader: null,
            msg: {
              header: "Server Error",
              message: (
                <Alert color="danger">
                  <p>Server failed with the following errors:</p>
                  {response.data.Errors.join("<br />")}
                </Alert>
              ),
            },
            keepOpen,
          });
        } else {
          // reload and close window
          if (resetLoader) resetLoader();
          this.setState({
            selectedReport: JSON.parse(JSON.stringify(params)),
            resetLoader: null,
            msg: {
              header: "Report Update",
              message: (
                <Alert color="success">Report updated successfully</Alert>
              ),
            },
          });
          if (!keepOpen) this.closeWindow();
          this.props.handlePageReload && this.props.handlePageReload();
        }
      });
  };

  handleSaveClick = (keepOpen) => {
    //const { handleOnSubmit } = this.props;
    const { isActive, internalUse } = this.state;
    const formState = this.inputFormWiz.state;
    var me = this;
    const {
      ftpDeliveryState,
      sftpDeliveryState,
      ftpHost,
      ftpPort,
      ftpUserName,
      ftpUserPassword,
      ftpUploadPath,
    } = formState;

    this.setState({
      savingReport: true,
    });

    if (ftpDeliveryState || sftpDeliveryState) {
      if (ftpHost && ftpPort && ftpUserName && ftpUserPassword) {
        var params = {
          IsSFTP: sftpDeliveryState,
          Host: ftpHost,
          Port: ftpPort,
          Username: ftpUserName,
          Password: ftpUserPassword,
          Path: ftpUploadPath,
        };
        axios
          .post("Reporting/Pipelines/checkftpsftpconnection", params)
          .then((response) => {
            if (response.data.Errors && response.data.Errors.length) {
              // confirmation window
              me.setState({
                invalidFtpConfirmModal: true,
                keepOpen: keepOpen,
              });
            } else {
              // save without asking...
              this.handleOnSubmit(
                { ...formState, isActive, internalUse },
                me.props.config.reportForCopyNewDef,
                me.resetLoader,
                keepOpen
              );
            }
          });
      } else {
        this.setState({
          msg: {
            savingReport: false,
            header: "FTP/SFTP Check",
            message: (
              <Alert style={{ width: "650px" }} color="danger">
                The following fields are required for FTP/SFTP delivery
                configuration:
                <br />
                Host, Port, Username, and Password.
              </Alert>
            ),
          },
        });
      }
    } else {
      this.handleOnSubmit(
        { ...formState, isActive, internalUse },
        this.props.config.reportForCopyNewDef,
        this.resetLoader,
        keepOpen
      );
    }
  };

  resetLoader = () => {
    this.setState({
      savingReport: false,
    });
  };

  toggleMsgBox = () => {
    this.setState({
      msg: {},
    });
  };

  toggleInvalidFtpConfirmModal = () => {
    this.setState({
      invalidFtpConfirmModal: !this.state.invalidFtpConfirmModal,
    });
  };
  handleYesConfirmInvalidFtpDialog = () => {
    const { config } = this.props;
    const { isActive, internalUse } = this.state;
    const formState = this.inputFormWiz.state;
    this.handleOnSubmit(
      { ...formState, isActive, internalUse },
      config.reportForCopyNewDef,
      this.resetLoader,
      this.state.keepOpen
    );
    this.setState({
      invalidFtpConfirmModal: false,
    });
  };
  handleNoConfirmInvalidFtpDialog = () => {
    this.setState({
      savingReport: false,
      invalidFtpConfirmModal: false,
    });
  };

  toggleShowMoreDesc = (showMoreDesc) => {
    this.setState({
      showMoreDesc: showMoreDesc,
    });
  };

  handleActiveChange = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  };
  handleInternalUseChange = () => {
    this.setState({
      internalUse: !this.state.internalUse,
    });
  };
  render() {
    const {
      config,
      isExternalUser,
      translate,
      /* user,
      subUser,
      isSubUser, */
    } = this.props;

    /* var currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    } */
    var inputData =
      ((this.inputFormWiz || {}).state || {}).params ||
      (
        (
          (
            (this.state.selectedReport?.reportDefComponentsParams || {})[0] ||
            {}
          ).data || {}
        ).scriptparams || {}
      ).inputData ||
      {};
    return (
      <Modal
        style={
          this.state.showMoreDesc
            ? { maxWidth: "unset" }
            : { maxWidth: "750px" }
        }
        isOpen={config.modalCopyNewConfigReport}
      >
        <div className="modal-header">
          <h5 className="modal-title">{translate("CloneConfiguredReport")}</h5>
          <div
            className="active-wizard"
            style={{ textAlign: "end", margin: "0 1em 0 0", flex: 1 }}
          >
            <input
              type="checkbox"
              id="isActiveReportClone"
              checked={this.state.isActive}
              style={{ margin: "5px" }}
              onChange={this.handleActiveChange}
            />
            <label
              htmlFor="isActiveReportClone"
              style={{ marginTop: "3px" }}
              className="form-check-label"
            >
              {translate("Active")}
            </label>
          </div>
          {!isExternalUser && (
            <div className="active-wizard">
              <input
                type="checkbox"
                id="internalUseClone"
                checked={this.state.internalUse}
                style={{ margin: "5px" }}
                onChange={this.handleInternalUseChange}
              />
              <label
                htmlFor="internalUseClone"
                style={{ marginTop: "3px" }}
                className="form-check-label"
              >
                {translate("Internal use only")}
              </label>
            </div>
          )}
          <button
            type="button"
            onClick={this.closeWindow}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">{String.fromCharCode(215)}</span>
          </button>
        </div>
        <ModalBody style={{ backgroundColor: "#d9d9d9", padding: "1px" }}>
          <WizardFormSecondPage
            ref={(inputFormWiz) => {
              this.inputFormWiz = inputFormWiz;
            }}
            selectedReportType={config.reportForCopyNewDef}
            selectedReport={config.reportForCopyNew}
            channels={config.channels}
            customers={config.customers}
            availableTimeZones={this.props.availableTimeZones}
            user={this.props.user}
            subUser={this.props.subUser}
            isSubUser={this.props.isSubUser}
            translate={translate}
            toggleShowMoreDesc={this.toggleShowMoreDesc}
            showMoreDesc={this.state.showMoreDesc}
            isActive={this.state.isActive}
          />
        </ModalBody>
        <ModalFooter
          className="text-center"
          style={{ fontSize: 11 + "px", fontWeight: "bold" }}
        >
          <button
            type="button"
            disabled={this.state.savingReport}
            className="btn btn-secondary"
            style={{ marginLeft: "15px" }}
            onClick={this.closeWindow}
          >
            {translate("Close")}
          </button>
          <button
            type="button"
            disabled={this.state.savingReport}
            className="btn btn-primary"
            style={{ marginLeft: "15px" }}
            onClick={() => this.handleSaveClick(true)}
          >
            {translate("Save")}
          </button>
          <button
            type="button"
            disabled={this.state.savingReport}
            className="btn btn-primary"
            style={{ marginLeft: "15px" }}
            onClick={() => this.handleSaveClick(false)}
          >
            {translate("Save and close")}
          </button>
          <RunTestReport
            reportDefinitionId={this.state.selectedReportId}
            reportPipelineDefinitionId={
              this.state.selectedReport?.reportPipelineDefinitionId
            }
            customerId={inputData.customer}
            project={inputData.project}
            projects={inputData.projects}
            channel={inputData.channel}
            timezone={inputData.timezone}
            disabled={this.state.savingReport}
            closeParentModal={() => {
              this.closeWindow();
              this.props.closeParentModal();
            }}
          />
          {this.state.savingReport && (
            <img
              alt=""
              style={{ float: "left", padding: "12px 12px" }}
              src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
            />
          )}
        </ModalFooter>
        <Modal
          style={{ width: "70vw", maxWidth: "95vw" }}
          isOpen={this.state.fullEventModal}
          toggle={this.toggleFullEventModal}
        >
          <ModalHeader toggle={this.toggleFullEventModal}>
            {translate("Details")}
          </ModalHeader>
          <ModalBody>
            <ReactJson
              src={this.state.eventJsonObj}
              enableClipboard
              displayDataTypes={false}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={!!this.state.msg.message}
          style={{ maxWidth: "700px", maxHeight: "700px" }}
          toggle={this.toggleMsgBox}
        >
          {this.state.msg.header && (
            <ModalHeader toggle={this.toggleMsgBox}>
              {this.state.msg.header}
            </ModalHeader>
          )}
          <ModalBody>{this.state.msg.message}</ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="primary"
              className="switchBtn"
              style={{ width: "100px" }}
              onClick={this.toggleMsgBox}
            >
              {translate("OK")}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.invalidFtpConfirmModal}
          toggle={this.toggleInvalidFtpConfirmModal}
        >
          <ModalHeader toggle={this.toggleInvalidFtpConfirmModal}>
            {translate("FTP_FTP Connection Checking")}
          </ModalHeader>
          <ModalBody>
            <Alert color="warning">
              {translate("FTP_SFTP checking failed")}"
            </Alert>
          </ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="secondary"
              style={{ width: "90px" }}
              onClick={this.handleYesConfirmInvalidFtpDialog}
            >
              {translate("Yes")}
            </Button>
            <Button
              color="primary"
              className="EventSearchSubmit"
              style={{ marginLeft: "60px", width: "90px" }}
              onClick={this.handleNoConfirmInvalidFtpDialog}
            >
              {translate("No")}
            </Button>
          </ModalFooter>
        </Modal>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const {
    config,
    locale,
    authentication,
    settings: { availableTimeZones },
  } = state;
  const { user, subUser, isSubUser } = authentication;
  return {
    config,
    availableTimeZones,
    user,
    subUser,
    isSubUser,
    translate: getTranslate(locale),
  };
}

const connectedCopyNewConfigReport = connect(mapStateToProps)(
  withRouter(CopyNewConfigReport)
);
export { connectedCopyNewConfigReport as CopyNewConfigReport };
